import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';

const getAuth = (state: IGlobalReduxStore) => state.auth;

export const sessionTokenSelector = createSelector(getAuth, (auth) => auth.token);
